<template>
  <shared-breadcrumb :parent="'man-insights'" :parent-text="$t('insights')" />
</template>

<script>
import SharedBreadcrumb from '~/components/breadcrumbs/SharedBreadCrumb'
export default {
  components: {
    SharedBreadcrumb
  }
}
</script>
